import axios from 'axios';
const URL = "https://abrightspot.org/wp-admin/admin-ajax.php";
function getAirData(args) { return axios.post(URL, args).then(response => response.data); }


export {URL, getAirData};